import React from "react";
import "./Include_Services.css";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";
import Common_heading from "../../../common/common_heading/Common_heading";

const Include_Services = () => {
  const { id } = useParams();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [service, setService] = useState({});
  const [serviceinclude, setServiceInclude] = useState([]);

  const getServiceInclude = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setService(res?.data || {});
      setServiceInclude(res?.data?.servinclude_id || []);
    }
  };

  useEffect(() => {
    if (id) {
      getServiceInclude();
    }
  }, [id]);

  return (
    <section className="Include_Services">
      <div className="container">
       

        <Common_heading
          title={<>{htmlToReactParser.parse(service.name)} Services Include</>}
        />

        <div className="row">
          {serviceinclude.map((item) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
              key={item.id}
            >
              <div className="service_card">
                <div className="service_icon_holder">
                  <img
                    src={IDS?.IMG_URL + item?.image}
                    alt={item.name}
                    className="service_icon"
                  />
                </div>

                <div className="service_content">
                  <h5 className="service_title">{item.name}</h5>

                  <p className="service_text">
                    {htmlToReactParser.parse(item?.description)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Include_Services;
